import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './styles.css';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { desautenticarParceiro } from '../../../store/modules/autenticacao/actions';
import Nav from '../../../components/Loja/Nav';
import NavMobile from '../../../components/Loja/NavMobile';
import ModalVideoWrapper from '../ModalVideoWrapper';
import { getClusterImageUrl } from '../../../utils/clusterImage';

export default function Header(props) {
  const dispatch = useDispatch();
  const parceiro = useSelector((state) => {
    return state.parceiro;
  });

  const [estadoModal, setEstadoModal] = useState(false);
  const [pesquisa, setPesquisa] = useState('');

  const autenticado = useSelector(
    (state) => state.autenticacao.autenticadoLoja
  );

  const sair = () => {
    dispatch(desautenticarParceiro());
  };

  const abrirModalVideoTutorial = () => {
    setEstadoModal(true);
  };

  const getFirstName = () => {
    const arr = parceiro.nome.split(' ');
    return arr[0];
  };

  const doSearch = (event) => {
    if (event.key == 'Enter') {
      window.location.href =
        `/loja?search=` + encodeURIComponent(pesquisa || '');
    }
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };

  const t = useSelector((state) => {
    return state;
  });

  return (
    <header className={props.auto ? 'header-home-auto' : 'header-home'}>
      <Container className="d-flex flex-column justify-content-center align-items-center text-center h-100 mt-2">
        {!autenticado ? (
          <Row className="w-100 mt-1 mb-2">
            <Col
              xs={12}
              sm={4}
              className="d-flex align-items-center justify-content-center"
            >
              <Link to="/loja" className="d-flex flex-column">
                {/* <img
                  style={{ width: '140px', marginLeft: '-30px' }}
                  src="/imagens/logo-fundo-claro.png"
                  alt="Logo Clube Pro Pintor"
                ></img> */}
                {/* <span className="f-10">Clube de Fidelidade</span> */}
                <img
                  className="w-100 nav-logo m-auto"
                  src="/imagens/logo-dark.png"
                  alt="Logo Clube Pro Pintor"
                ></img>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <span className="f-10">Administrado e Desenvolvido por</span>
                  <div className="d-flex flex-row justify-content-center align-items-center">
                    <img
                      className="nav-brand m-auto"
                      src="/imagens/logo-smart.svg"
                      alt="Logo Smart"
                    ></img>
                    <span className="f-10 text-nowrap">
                      Clube de Fidelidade
                    </span>
                  </div>
                </div>
              </Link>
            </Col>
            <Col xs={12} sm={8} className="header-acoes">
              <Link to="login" className="link-colored mr-3">
                <i className="fas fa-user mr-1"></i> ENTRAR
              </Link>
              <Link to="cadastrar" className="border-colored mr-3">
                <i className="fas fa-user-edit mr-1"></i> CADASTRE-SE
              </Link>
              <Link to="relatorio" className="border-colored mr-3">
                <i className="fas fa-store mr-1"></i> LOJISTA
              </Link>
              <button
                onClick={abrirModalVideoTutorial}
                to="cadastrar"
                className="border-colored p-1"
              >
                <i className="fas fa-video mr-1"></i> TUTORIAL
              </button>
            </Col>
          </Row>
        ) : (
          <>
            <Row className="d-flex d-md-none w-100">
              <NavMobile />
            </Row>
            <Row className="w-100 my-3">
              <Col
                xs={12}
                md={2}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="d-none d-md-flex flex-column">
                  <Link to="/home" className="d-none d-md-flex flex-column">
                    {/*<span className="f-10">Clube de Fidelidade</span>*/}
                    <img
                      className="w-100 nav-logo m-auto"
                      src="/imagens/logo-dark.png"
                      alt="Logo Clube Pro Pintor"
                    ></img>

                    <div className="d-none d-md-flex flex-column justify-content-center align-items-center">
                      <span className="f-10">
                        Administrado e Desenvolvido por
                      </span>
                      <div className="d-flex flex-row justify-content-center align-items-center">
                        <img
                          className="nav-brand m-auto"
                          src="/imagens/logo-smart.svg"
                          alt="Logo Smart"
                        ></img>
                        <span className="f-10 text-nowrap">
                          Clube de Fidelidade
                        </span>
                      </div>
                    </div>
                  </Link>{' '}
                </div>
              </Col>
              <Col xs={12} md={10}>
                <Row className="d-flex justify-content-between ">
                  <Col xs={12}>
                    <div className="d-flex justify-content-between">
                      <div className="d-none d-md-flex gap-3">
                        {parceiro?.cluster?.img && (
                          <div className="d-flex flex-row justify-content-center align-items-center">
                            <img
                              src={getClusterImageUrl(parceiro?.cluster?.img)}
                              style={{
                                width: '70px',
                                height: '70px',
                                backgroundColor: '#fff',
                                borderRadius: '100%',
                                padding: '0.5rem',
                              }}
                            />
                          </div>
                        )}
                        <div
                          className="text-start"
                          style={{ textAlign: 'start', marginLeft: '1rem' }}
                        >
                          <span>
                            Olá,{' '}
                            <b style={{ color: '#6feffa' }}>
                              {getFirstName()}!
                            </b>{' '}
                            <br />
                            <span>
                              Seu saldo atual é de{' '}
                              <b style={{ color: '#6feffa' }}>
                                {Number(parceiro.saldoPontos).toLocaleString(
                                  'pt-BR'
                                )}{' '}
                                pontos
                              </b>
                            </span>{' '}
                            <br />{' '}
                            {parceiro?.cluster?.nome && (
                              <span>
                                <strong>Você é um pintor </strong>
                                <strong style={{ textTransform: 'uppercase' }}>
                                  {parceiro?.cluster?.nome}!{' '}
                                </strong>{' '}
                                <br />
                                {parceiro?.nextCluster?.nome && (
                                  <span
                                    style={{
                                      fontSize: '14px',
                                      textTransform: 'uppercase',
                                    }}
                                  >
                                    <Link to="/cluster">
                                      <strong style={{ color: 'yellow' }}>
                                        Saiba o que você precisa para se tornar{' '}
                                        {parceiro?.nextCluster?.nome}
                                      </strong>
                                    </Link>
                                  </span>
                                )}
                              </span>
                            )}{' '}
                            {!parceiro?.cluster?.nome && (
                              <Link to="/cluster">
                                <strong style={{ color: 'yellow' }}>
                                  Você é um pintor Iniciante. SAIBA COMO SUBIR
                                  DE NÍVEL.
                                </strong>
                              </Link>
                            )}{' '}
                          </span>
                        </div>
                      </div>
                      <div className="d-block d-sm-flex d-md-none gap-3">
                        <div className="text-start">
                          <span>
                            Olá,{' '}
                            <b style={{ color: '#6feffa' }}>
                              {getFirstName()}!
                            </b>{' '}
                            <br />
                            <span>
                              Seu saldo atual é de{' '}
                              <b style={{ color: '#6feffa' }}>
                                {Number(parceiro.saldoPontos).toLocaleString(
                                  'pt-BR'
                                )}{' '}
                                pontos
                              </b>
                            </span>{' '}
                          </span>
                        </div>
                      </div>
                      <div
                        className="d-none d-md-block"
                        style={{ paddingTop: '12px' }}
                      >
                        <table className="w-100">
                          <tbody>
                            <tr>
                              <td className="text-right">
                                <Link className="nav-indicacao" to="/indicacao">
                                  INDIQUE E GANHE
                                </Link>
                              </td>
                              <td
                                className="text-right"
                                style={{ color: '#fff', width: '85px' }}
                              >
                                <a href="javascript:void(0)" onClick={logout}>
                                  Sair{' '}
                                  <i
                                    style={{ color: '#6feffa' }}
                                    className="fa fa-sign-out-alt"
                                  ></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="d-block d-sm-block d-md-none"
                        style={{ paddingBottom: '52px' }}
                      >
                        <Link
                          className="btn-block nav-indicacao"
                          to="/indicacao"
                          style={{ padding: '6px 8px', borderRadius: '6px' }}
                        >
                          INDIQUE E GANHE
                        </Link>{' '}
                        <div className="d-block d-sm-block d-md-none">
                          <a href="javascript:void(0)" onClick={logout}>
                            Sair{' '}
                            <i
                              style={{ color: '#6feffa' }}
                              className="fa fa-sign-out-alt"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="d-block d-sm-flex d-md-none">
                      <div className="d-flex flex-row justify-content-center align-items-center  gap-2">
                        {parceiro?.cluster?.nome && (
                          <img
                            src={getClusterImageUrl(parceiro?.cluster?.img)}
                            style={{
                              width: '50px',
                              height: '50px',
                              backgroundColor: '#fff',
                              borderRadius: '100%',
                              padding: '0.5rem',
                            }}
                          />
                        )}

                        <span>
                          {parceiro?.cluster?.nome && (
                            <span>
                              Você é um{' '}
                              <strong style={{ textTransform: 'uppercase' }}>
                                PINTOR {parceiro?.cluster?.nome}!{' '}
                              </strong>{' '}
                              <br />
                              {parceiro?.nextCluster?.nome && (
                                <span
                                  style={{
                                    fontSize: '14px',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  <Link to="/cluster" className="nav-link">
                                    <strong style={{ color: 'yellow' }}>
                                      SAIBA COMO SUBIR DE NIVEL
                                    </strong>
                                  </Link>
                                </span>
                              )}
                            </span>
                          )}
                          {!parceiro?.cluster?.nome && (
                            <span>
                              Você é um pintor Iniciante. <br />
                              <Link to="/cluster">
                                <strong style={{ color: 'yellow' }}>
                                  SAIBA COMO SUBIR DE NÍVEL.
                                </strong>
                              </Link>
                            </span>
                          )}{' '}
                        </span>
                      </div>
                    </div>
                  </Col>

                  {/*<Col xs={4} md={1} className="my-2 mt-2">*/}
                  {/*  <button onClick={sair} className="nav-sair">*/}
                  {/*    <i className="fas fa-sign-out-alt mr-1" /> Sair*/}
                  {/*  </button>*/}
                  {/*</Col>*/}
                </Row>
                <div className="d-none d-md-flex w-100">
                  <div style={{ marginLeft: '-15px' }}>
                    <Nav />
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <ModalVideoWrapper
        show={estadoModal}
        onHide={() => setEstadoModal(false)}
      >
        <video
          autoPlay
          autoStart
          controls
          className="w-100"
          src="/videos/tutorial.mp4"
        ></video>
      </ModalVideoWrapper>
    </header>
  );
}
